<template>
    <div>
    <h3 class="content-block openware-form-title">{{ title }}</h3>
    <p>{{ data }}</p>
        <DxDataGrid
            :key-expr="id"
            :data-source="CustomStoreMain"
            :columns="columns"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :column-auto-width="true"
            :show-borders="true"
            :show-column-lines="true"
            :show-row-lines="true"
            :row-alternation-enabled="true"
            :focused-row-enabled="true"
            :word-wrap-enabled="true"
            ref="dataGrid"
            @exporting="onExporting"
            @initNewRow="initNewRow"
        >
            <DxPaging 
                :enabled="true"
                :page-size="5"
            />

            <DxFilterRow :visible="true"/>

            <DxHeaderFilter :visible="true"/>

            <DxPager
                :visible="true"
                :allowed-page-sizes="pageSizes"
                :display-mode="displayMode"
                :show-page-size-selector="true"
                :show-info="true"
                :show-navigation-buttons="true"
            />

            <DxGroupPanel :visible="false"/>

            <DxSorting mode="multiple"/>

            <DxEditing
                :allow-updating="true"
                :allow-adding="true"
                :allow-deleting="true"
                :texts= "{
                        addRow: 'Προσθήκη',
                        deleteRow: 'Διαγραφή',
                        editRow:'Επεξεργασία',
                        saveAllChanges:'Αποθήκευση Όλων',
                        cancelAllChanges:'Ακύρωση Όλων'
                    }"
                mode="batch"
            >
            </DxEditing>


            <DxColumn
                data-field="title"
                caption="Ομάδα"
            >
                <DxRequiredRule/>
            </DxColumn>

            <DxExport
                :enabled="true"
                :formats="['xlsx']"
                :texts= "{
                            exportAll: 'Εξαγωγή σε {0}',
                        }"
            />

        </DxDataGrid>
    </div>
</template>

<script setup>
    import {
        DxDataGrid,
        DxColumn,
        DxEditing, 
        DxPaging, 
        DxPager,
        DxGroupPanel,
        DxSorting,
        DxFilterRow,
        DxHeaderFilter,
        DxExport,
        DxRequiredRule,
        //DxToolbar,
        //DxItem,
        //DxButton,
    } from 'devextreme-vue/data-grid'

    import 'whatwg-fetch'
    import CustomStore from 'devextreme/data/custom_store'
    import OParameters from '../es-globals'

    import { ref, /*reactive, computed, onMounted */} from 'vue'

    const dataGrid = ref(null)

    const URL_SERVICE = OParameters.Host.URI + 'ow_usergroups'

    const CustomStoreMain= new CustomStore({
        key: 'id',
        //loadMode: 'raw',
        load: () => sendRequest(URL_SERVICE),
        //insert: (values) => sendRequest(URL_SERVICE, 'POST', values),
        //update: (key, values) => sendRequest(URL_SERVICE + '/' + encodeURIComponent(key), 'PUT', values),
        //remove: (key) => sendRequest(URL_SERVICE + '/' + encodeURIComponent(key), 'DELETE'),
        byKey: (key) => sendRequest(URL_SERVICE + "/" + encodeURIComponent(key)),
    })

    const title= 'Ομάδες Χρηστών'
    const pageSizes= [5, 10, 20]

    // 
    //  Based on: https://js.devexpress.com/Demos/WidgetsGallery/Demo/DataGrid/CRUDOperations/Vue/GreenMist/
    //
    const sendRequest = (url, method = 'GET', values = {}) => {
        // console.log('LOG: ' + url + ' METHOD: ' + method + ' VALUES: ' + JSON.stringify(values, null, 4));
        if (method === 'GET') {
            return fetch(url, {
                method,
                credentials: 'include',
            })
            .then((response) => response.json()
            .then((json) => {
                if (response.ok) return json.records;
                throw json.Message;
            }));
        }
        return fetch(url, {
            method,
            body: JSON.stringify(values),
            headers: {
                'Content-Type': 'application/json', //'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            },
            credentials: 'include',
        }).then((result) => {
            if (result.ok) {
                return result.text().then((text) => text && JSON.parse(text));
            }
            return result.json().then((json) => {
                throw json.Message;
            });
        });
    }

    const onExporting = (e) =>{
        OParameters.methods.exportDataGridToPdfExcel(e, title)
    }

</script>
<style lang="scss">
</style>
